import { render, staticRenderFns } from "./editMember.vue?vue&type=template&id=59b79ca8&scoped=true&"
import script from "./editMember.vue?vue&type=script&lang=js&"
export * from "./editMember.vue?vue&type=script&lang=js&"
import style0 from "./editMember.vue?vue&type=style&index=0&id=59b79ca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b79ca8",
  null
  
)

export default component.exports